import React, { useState, useEffect } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Button from '../../ui/Button';
import './Hero.css';

function usePrefersReducedMotionOrMobile() {
  const prefersReducedMotion = useReducedMotion();
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 768px)');
    setIsMobile(mq.matches);
    const listener = () => setIsMobile(mq.matches);
    mq.addEventListener('change', listener);
    return () => mq.removeEventListener('change', listener);
  }, []);
  return Boolean(prefersReducedMotion) || isMobile;
}

function Hero() {
  const navigate = useNavigate();
  const reduceMotion = usePrefersReducedMotionOrMobile();

  function scrollToAbout() {
    const element = document.getElementById('about');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });
    }
  }

  const floatingVariants = {
    float: {
      y: [0, -20, 0],
      transition: {
        duration: 6,
        repeat: Infinity,
        ease: 'easeInOut',
      },
    },
  };

  const fadeInUp = {
    initial: { opacity: 0, y: 30 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6, ease: 'easeOut' },
  };

  return (
    <section id="intro" className="landing-hero">
      {/* Floating shapes - disabled on mobile/reduced-motion for scroll performance */}
      <motion.div
        className="floating-shape floating-shape--1"
        variants={floatingVariants}
        animate={reduceMotion ? false : 'float'}
      />
      <motion.div
        className="floating-shape floating-shape--2"
        variants={floatingVariants}
        animate={reduceMotion ? false : 'float'}
        transition={{ delay: 1, duration: 8 }}
      />
      <motion.div
        className="floating-shape floating-shape--3"
        variants={floatingVariants}
        animate={reduceMotion ? false : 'float'}
        transition={{ delay: 2, duration: 7 }}
      />

      <div className="landing-hero-content">
        <motion.h1
          className="landing-hero-headline"
          {...fadeInUp}
        >
          Work with clarity. Move with purpose.
        </motion.h1>

        <motion.p
          className="landing-hero-subtext"
          {...fadeInUp}
          transition={{ delay: 0.2 }}
        >
          We turn “Wait… what was I doing?” into “Got it.”
        </motion.p>

        <motion.div
          className="landing-hero-actions"
          {...fadeInUp}
          transition={{ delay: 0.4 }}
        >
          <Button
            variant="primary"
            onClick={() => navigate('/signin')}
            className="landing-hero-cta-primary"
          >
            Try for Free →
          </Button>
          <Button
            variant="secondary"
            onClick={scrollToAbout}
            className="landing-hero-cta-secondary"
          >
            Learn More
          </Button>
        </motion.div>
      </div>
    </section>
  );
}

export default Hero;
